module.exports = __webpack_public_path__ + "img/ZAframe-MH4000-frontcreative.4134dd54.jpg";